module.exports = __webpack_public_path__ + "img/prt0004.prt.48d90ea9.jpg";